"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    js: (src, optinos) => {
        return new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                return resolve(true);
            }
            const script = document.createElement('script');
            if (optinos === null || optinos === void 0 ? void 0 : optinos.type) {
                script.type = optinos.type;
            }
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = (e) => reject(e);
            document.head.append(script);
        });
    }
};
